import { useDispatch, useSelector } from 'react-redux';
import {
  cancelCollaboration,
  exportSplits,
  getSplitPayments,
  inviteToCollaborate,
  performCollaborationAction,
  postCreateSplitPayment,
  selectCollaboration,
  selectUserType,
  showExportSplits,
  validateMerchantCollaborator,
} from './actions';
import { SplitPaymentsSelectors } from './selectors';
import { CreateSplitPayment, SplitPaymentFilters, SplitPaymentsActionType, SplitUserType } from './interfaces';
import { ExportType } from '../interfaces';

export const useSplitPayments = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(SplitPaymentsSelectors.getLoading),
    formLoading: useSelector(SplitPaymentsSelectors.getFormLoading),
    error: useSelector(SplitPaymentsSelectors.getError),
    errorInfo: useSelector(SplitPaymentsSelectors.getErrorInfo),
    collaboratorEmailValidated: useSelector(SplitPaymentsSelectors.getCollaboratorEmailValidated),
    selectUserType: (userType: SplitUserType) => dispatch(selectUserType(userType)),
    createSplitPaymentPayload: useSelector(SplitPaymentsSelectors.getCreateSplitPaymentPayload),
    postCreateSplitPayment: () => dispatch(postCreateSplitPayment()),
    getSplitPayments: (page: number, filters?: SplitPaymentFilters) => dispatch(getSplitPayments(page, filters)),
    step: useSelector(SplitPaymentsSelectors.getStep),
    collaborationIdSelected: useSelector(SplitPaymentsSelectors.getCollaborationIdSelected),
    allSplitPayments: useSelector(SplitPaymentsSelectors.getAllSplitPayments),
    requestSuccess: useSelector(SplitPaymentsSelectors.getRequestSuccess),
    inviteToCollaborate: () => dispatch(inviteToCollaborate()),
    validateMerchantCollaborator: (payload: CreateSplitPayment) => dispatch(validateMerchantCollaborator(payload)),
    performCollaborationAction: (id: number, action: SplitPaymentsActionType) =>
      dispatch(performCollaborationAction(id, action)),
    cancelCollaboration: (id: number) => dispatch(cancelCollaboration(id)),
    selectCollaboration: (collaborationId: number) => dispatch(selectCollaboration(collaborationId)),
    userType: useSelector(SplitPaymentsSelectors.getUserType),
    export: useSelector(SplitPaymentsSelectors.getExport),
    exportType: useSelector(SplitPaymentsSelectors.getExportType),
    showExportSplits: (show: boolean) => dispatch(showExportSplits(show)),
    exportSplits: (filter: string, type: ExportType, id: number) => dispatch(exportSplits(filter, type, id)),
  };
};
